import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-thank-dialog',
  templateUrl: './thank-dialog.component.html',
  styleUrls: ['./thank-dialog.component.scss']
})
export class ThankDialogComponent implements OnInit {

  confirmMessage: string;
  remark:string;

  // constructor(
  //   public dialogRef: MatDialogRef<ConfirmDialogComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: any
  // ) { }
  constructor(
    public dialogRef: MatDialogRef<ThankDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

}
